var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
export var useAppAIHubPoCStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
    },
    content: {
        display: 'flex',
        position: 'absolute',
        left: 0,
        bottom: 0,
        right: 0,
        top: '0px',
        backgroundColor: tokens.colorNeutralBackground2,
    },
    contentShellShyHeaderMode: {
        top: '8px',
    },
    // Styles derived from DragAndDropUpload.styles.tsx that is now not part of ai hub component
    scrollContent: __assign(__assign({ boxShadow: tokens.shadow4, display: 'flex', flexDirection: 'column', height: '100%' }, shorthands.overflow('visible', 'hidden')), { position: 'relative', width: '100%', zIndex: 0, '@media screen and (max-width: 320px) ': {
            overflowX: 'hidden',
        } }),
    scrollContentNoShadow: {
        boxShadow: 'none',
        borderTop: "1px solid ".concat(tokens.colorNeutralStroke2),
    },
});
//# sourceMappingURL=AppAIHubPoC.styles.js.map